// 定义常量

// 年级列表
const gradeCodeList = [{
  value: '13',
  name: '学前/Preschool'
}, {
  value: '12',
  name: '1年级/Grade 1'
}, {
  value: '11',
  name: '2年级/Grade 2'
}, {
  value: '10',
  name: '3年级/Grade 3'
}, {
  value: '9',
  name: '4年级/Grade 4'
}, {
  value: '8',
  name: '5年级/Grade 5'
}, {
  value: '7',
  name: '6年级/Grade 6'
}, {
  value: '6',
  name: '7年级(初一)/Grade 7'
}, {
  value: '5',
  name: '8年级(初二)/Grade 8'
}, {
  value: '4',
  name: '9年级(初三)/Grade 9'
}, {
  value: '3',
  name: '10年级(高一)/Grade 10'
}, {
  value: '2',
  name: '11年级(高二)/Grade 11'
}, {
  value: '1',
  name: '12年级(高三)/Grade 12'
}, {
  value: '0',
  name: '大一/Freshman'
}, {
  value: '-1',
  name: '大二/Sophomore'
}, {
  value: '-2',
  name: '大三/Junior'
}, {
  value: '-3',
  name: '大四/Senior'
}]
// const certificateTypeList = [{
//   value: 1,
//   name: '身份证'
// }, {
//   value: 2,
//   name: '护照'
// }, {
//   value: 3,
//   name: '其它证件'
// }]
const nationalCodes = [{
  value: 1,
  name: '中国/China'
}, {
  value: 4,
  name: '中国香港/Hong Kong, China'
}, {
  value: 2,
  name: '中国澳门/Macao, China'
}, {
  value: 3,
  name: '中国台湾/Taiwan, China'
}, {
  value: 5,
  name: '其他国家/Other Countries'
}]

// 文件过滤
const fileAccept = {
  pdf: 'application/pdf',          // pdf
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',  // pptx
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',      // docx
  doc: 'application/msword',       // doc
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel'
}

const scoreInfo = {
  sign: {
    action: '签到',
    score: 10
  },
  read: {
    action: '阅读 ',
    score: 10
  },
  praise: {
    action: '点赞',
    score: 20
  },
  comment: {
    action: '评论',
    score: 20
  },
  vote: {
    action: '投票',
    score: 20
  },
  post: {
    action: '发帖',
    score: 30
  },
  contribut: {
    action: '投稿',
    score: 60
  }
}

export default {
  gradeCodeList,
  scoreInfo,
  // certificateTypeList,
  fileAccept,
  nationalCodes
}



// WEBPACK FOOTER //
// ./src/assets/js/constant.js